import HomepageRecettes from './HomepageRecettes';

export default HomepageRecettes;
